export default __webpack_public_path__ + "static/media/icon-business.467d6aa9.svg";